import { Trash2 } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "./button";

interface DeleteButtonProps {
  onClick: () => void;
  isDeleting: boolean;
  disabled?: boolean;
  /** Applied to the label — e.g. to hide it inside a compact toolbar. */
  textClassName?: string;
  /** When false, skip the hover tooltip (e.g. a parent already provides one). */
  tooltip?: ReactNode | false;
}

export function DeleteButton({
  onClick,
  isDeleting,
  disabled,
  textClassName,
  tooltip = "Delete",
}: DeleteButtonProps) {

  return (
    <Button
      variant="outline"
      size="sm"
      className="hover:bg-red-500 hover:text-white transition-colors"
      onClick={onClick}
      disabled={isDeleting || disabled}
      icon={Trash2}
      text="Delete"
      textClassName={textClassName}
      tooltip={tooltip === false ? undefined : tooltip}
      aria-label="Delete"
    />
  );
}